/* Claude Design Homepage pond: two swans roam the trim and kiss.
   Source: design-export/atelier-ancestro/Homepage.dc.html startSwans().
   prefers-reduced-motion: static kiss pose, no RAF / heart. */
(function () {
  var SW = 86;
  var BEAK = 78;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function mk(el, x) {
    return {
      el: el,
      x: x,
      target: x,
      speed: 0.175,
      face: 1,
      pause: 0,
      phase: Math.random() * 6.28,
      kiss: 0,
      zone: [0, 1],
    };
  }

  function pose(s, x, face) {
    s.el.style.transform =
      "translate(" + x.toFixed(1) + "px,0px) scaleX(" + face + ") rotate(0deg)";
  }

  function startPond(pond) {
    var birds = pond.querySelectorAll("[data-aa-swan]");
    var heart = pond.querySelector("[data-aa-swan-heart]");
    if (birds.length < 2) return;

    var sa = birds[0];
    var sb = birds[1];
    var reduce = reduceMotion();
    var PW = pond.clientWidth || 0;
    var pair = [mk(sa, PW * 0.1), mk(sb, PW * 0.8)];
    pair[0].zone = [0, 0.3];
    pair[1].zone = [0.7, 1];

    if (reduce || PW < 1) {
      var mid = Math.max(PW, SW * 2) / 2;
      pose(pair[0], mid - BEAK, 1);
      pose(pair[1], mid - 6, -1);
      return;
    }

    var mode = "roam";
    var cool = 0;
    var kissPoint = 0;
    var kissT = 0;
    var dwell = null;
    var raf = 0;

    function startKiss() {
      var p = pond.clientWidth / 2;
      pair[0].target = p - BEAK;
      pair[0].face = 1;
      pair[1].target = p - 6;
      pair[1].face = -1;
      pair[0].speed = pair[1].speed = 0.475;
      pair[0].pause = pair[1].pause = 0;
      pair[0].kiss = 1;
      pair[1].kiss = -1;
      kissPoint = p;
      mode = "approach";
    }

    function popHeart() {
      if (!heart || typeof heart.animate !== "function") return;
      heart.style.left = kissPoint - 11 + "px";
      heart.animate(
        [
          { opacity: 0, transform: "translateY(6px) scale(0.3)" },
          { opacity: 1, transform: "translateY(-4px) scale(1.15)", offset: 0.25 },
          { opacity: 1, transform: "translateY(-10px) scale(1)", offset: 0.7 },
          { opacity: 0, transform: "translateY(-22px) scale(0.9)" },
        ],
        { duration: 1600, easing: "cubic-bezier(0.19,1,0.22,1)" }
      );
    }

    function onPointer(ev) {
      if (mode !== "roam" || performance.now() < cool) return;
      var r = pond.getBoundingClientRect();
      var inside = ev.clientY >= r.top - 56 && ev.clientY <= r.bottom + 4;
      if (inside && !dwell) {
        dwell = setTimeout(function () {
          dwell = null;
          if (mode === "roam" && performance.now() >= cool) startKiss();
        }, 2000);
      } else if (!inside && dwell) {
        clearTimeout(dwell);
        dwell = null;
      }
    }

    function onLeave() {
      if (dwell) {
        clearTimeout(dwell);
        dwell = null;
      }
    }

    document.addEventListener("pointerleave", onLeave);
    window.addEventListener("pointermove", onPointer);

    function loop(t) {
      var width = pond.clientWidth;
      var W = width - SW;
      if (mode === "approach" && pair.every(function (s) { return Math.abs(s.target - s.x) < 1; })) {
        mode = "kiss";
        kissT = t;
        popHeart();
      }
      if (mode === "kiss" && t - kissT > 1700) {
        mode = "roam";
        cool = performance.now() + 6000;
        pair.forEach(function (s) {
          s.kiss = 0;
          s.pause = 20 + Math.random() * 60;
          s.target = s.x;
        });
      }
      pair.forEach(function (s) {
        if (mode === "roam") {
          if (s.pause > 0) {
            s.pause -= 1;
          } else {
            var d = s.target - s.x;
            if (Math.abs(d) < 1) {
              s.pause = 40 + Math.random() * 180;
              var lo = s.zone[0] * width;
              var hi = Math.max(lo, s.zone[1] * width - SW);
              var nt = lo + Math.random() * (hi - lo);
              if (Math.abs(nt - s.x) < 40) nt = s.x < (lo + hi) / 2 ? hi : lo;
              s.target = nt;
              s.speed = 0.125 + Math.random() * 0.225;
            } else {
              s.face = d > 0 ? 1 : -1;
              s.x += Math.sign(d) * Math.min(Math.abs(d), s.speed);
            }
          }
        } else if (mode === "approach") {
          var ad = s.target - s.x;
          if (Math.abs(ad) >= 1) {
            s.face = Math.abs(ad) > 30 ? (ad > 0 ? 1 : -1) : s.kiss;
            s.x += Math.sign(ad) * Math.min(Math.abs(ad), s.speed);
          } else {
            s.x = s.target;
            s.face = s.kiss;
          }
        }
        var lean = mode === "kiss" ? 3 : 0;
        var bob = Math.sin(t / 900 + s.phase) * (mode === "kiss" ? 0.5 : 1.4);
        var tilt = Math.sin(t / 1300 + s.phase) * 1.5 + lean;
        s.el.style.transform =
          "translate(" +
          s.x.toFixed(1) +
          "px," +
          bob.toFixed(2) +
          "px) scaleX(" +
          s.face +
          ") rotate(" +
          tilt.toFixed(2) +
          "deg)";
      });
      raf = requestAnimationFrame(loop);
    }

    raf = requestAnimationFrame(loop);
    window.setTimeout(function () {
      if (mode === "roam" && performance.now() >= cool) startKiss();
    }, 1800);

    pond._aaSwanTeardown = function () {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onPointer);
      document.removeEventListener("pointerleave", onLeave);
      if (dwell) clearTimeout(dwell);
    };
  }

  function boot() {
    document.querySelectorAll("[data-aa-swan-pond]").forEach(startPond);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
